<template>
  <div></div>
</template>

<script>
  import Vuex from 'vuex'
  import VuexFire from 'vuexfire';
  import firebase from 'firebase'
  import store from '../vuex/store'

  var config = {
    apiKey: "AIzaSyBRG8MJ3_KDZz42GABLHAp2YsVcawux5xE",
    authDomain: "aidsimpact-e87b7.firebaseapp.com",
    databaseURL: "https://aidsimpact-e87b7.firebaseio.com",
    storageBucket: "aidsimpact-e87b7.appspot.com",
    messagingSenderId: "555300387684"
  };
  var firebaseApp = firebase.initializeApp(config);
  var db = firebase.database();
  var firebaseAuth = firebase.auth();

  export default {
    store,
    created: function () {
      this.listenAuth();
      //this.checkAuth();
    },
    firebase: {
      //contacts: db.ref('contacts')
    },
    watch: {
      authData (val) {
        if (!val) {
          //this.redirectLogin
          //this.$route.router.go('/login')
        }
      }
    },
    methods: {
      listenAuth: function () {
        firebaseAuth.onAuthStateChanged(function (authData) {
          store.dispatch({type: 'updateAuth', payload: authData});
          if (authData) {
            //this.$router.go('/');
          }
        });
      },
      checkAuth: function () {
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** dbfunctions.vue?1dbccfde
 **/